import React from 'react';
export function Header() {
  return <header className="bg-white border-b border-gray-300" data-id="element-5">
      <div className="max-w-7xl mx-auto px-4 py-4" data-id="element-6">
        <div className="flex items-start justify-between gap-8" data-id="element-7">
          {/* Logo Section */}
          <div className="flex items-center gap-4" data-id="element-8">
            <div className="w-32 h-32 bg-gray-200 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-9">
              <svg className="w-20 h-20 text-gray-600" fill="currentColor" viewBox="0 0 24 24" data-id="element-10">
                <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-11" />
                <circle cx="12" cy="12" r="6" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-12" />
                <circle cx="12" cy="12" r="2" fill="currentColor" data-id="element-13" />
              </svg>
            </div>
            <div data-id="element-14">
              <h1 className="text-4xl font-bold leading-tight" data-id="element-15">
                <span className="text-red-700" data-id="element-16">USA</span>
                <br data-id="element-17" />
                <span className="text-blue-900" data-id="element-18">Bearings</span>
                <br data-id="element-19" />
                <span className="text-blue-900" data-id="element-20">& Belts</span>
              </h1>
              <p className="text-sm text-gray-700 italic mt-1" data-id="element-21">
                "We get things moving!"
              </p>
            </div>
          </div>

          {/* Contact & Search Section */}
          <div className="flex flex-col gap-4 flex-1 max-w-md" data-id="element-22">
            <div className="text-right" data-id="element-23">
              <p className="text-lg font-semibold text-gray-800" data-id="element-24">
                Commercial Sales Only 863-337-4984
              </p>
              <p className="text-sm text-gray-600" data-id="element-25">
                Business Hours M-Fri 9:00-3:00 ET
              </p>
            </div>

            <div className="bg-white border border-gray-300" data-id="element-26">
              <div className="bg-red-900 text-white px-4 py-2 font-semibold" data-id="element-27">
                PRODUCT SEARCH
              </div>
              <div className="p-4 bg-gray-50" data-id="element-28">
                <input type="text" placeholder="Search products..." className="w-full px-3 py-2 border border-gray-300 mb-2" data-id="element-29" />
                <button className="w-full bg-blue-700 text-white px-4 py-2 font-semibold hover:bg-blue-800" data-id="element-30">
                  Search
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>;
}